module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/icon_gold.8fe3bdb4.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/icon_gold.png
// module id = 3001
// module chunks = 11